// extracted by mini-css-extract-plugin
export default {"crossfadeItem":"Crossfade_crossfadeItem__daUOD","visible":"Crossfade_visible__9MSPH","hidden":"Crossfade_hidden__u+VO0"};